import PropTypes from "prop-types";
import Link from "next/link";
import { sanitizedCountryName } from "helpers/formatting";
import { getCode } from "country-list";
import { CircleFlag } from "react-circle-flags";
import Title from "components/shared/stays/Title";
import styles from "components/destination/CountryListItem.module.scss";

export default function CountryListItem({ name, url }) {
  return (
    <Link prefetch={false} className={styles.component} href={url}>
      <div className={styles.image}>
        <CircleFlag
          countryCode={getCode(sanitizedCountryName(name))?.toLowerCase()}
          height={40}
          alt={name}
          aria-label={name}
        />
      </div>
      <div className={styles.text}>
        <Title tag="h3" size={5}>
          {name}
        </Title>
      </div>
    </Link>
  );
}

CountryListItem.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
